import { Injectable, TemplateRef } from '@angular/core';

type TypeAddonNames = 'inCinemasAddon' | 'brandedInCinemasAddon' | 'backCardExtraDescription';

/**
 * TOFIX
 * This service has an issue and don't work as a singelton.
 * This can be replicated with the comoponents related to the
 * "movie page resolver" in the "in cinemas" part. With
 * legacy branded pages work fine.
 *
 * If fixed remove this service from ChannelService
 */

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
  private templates = {};

  /**
   * You can add templates to this service in order to make them available in the site
   * @param name It is the name of the template currently we use  'inCinemasAddon' | 'brandedInCinemasAddon' | 'backCardExtraDescription' as a fixed ones
   * but for any other template you can use the one you like;
   * @param template It is the template that will be used
   */
  add(name: TypeAddonNames | any, template: TemplateRef<unknown>) {
    // preventing adding the same template multiple times
    if (this.templates[name]) {
      console.error('Template', name, 'already added');
      return;
    }

    this.templates[name] = template;
  }

  /**
   * @param name The name of the template
   * @returns the template if found or undefined
   */
  get(name: TypeAddonNames | any): TemplateRef<unknown> {
    return this.templates[name];
  }

  getTemplates() {
    return this.templates;
  }
}
